<div
  class="hx-radio-group__container"
  role="radiogroup"
  [attr.aria-describedby]="ariaDescribedby()"
  [attr.aria-invalid]="_isInErrorState() || null"
  [attr.aria-label]="ariaLabel()"
  [attr.aria-labelledby]="ariaLabelledby()">
  <ng-content />
</div>

<!-- Error Message -->
@if (_errorMessage()) {
  <span hx-error>{{ _errorMessage() }}</span>
}
